import type { PayexThunkAction } from 'store/configureStore';

import { getFieldValue, getRecipientId, isFetching } from 'selectors';
import { errorNotifier } from 'utils/errorNotifier/errorNotifier';
import type { I18n } from 'utils/translations';

import type { SaveAcademicParams } from 'services/payex/academic/types';

import { isEmpty } from 'lodash';
import {
  FETCH_ACADEMIC_FAILURE,
  FETCH_ACADEMIC_REQUEST,
  FETCH_ACADEMIC_SUCCESS,
  PROMOTIONS_OPT_IN_FIELD,
  SAVE_ACADEMIC_FIELDS_FAILURE,
  SAVE_ACADEMIC_FIELDS_REQUEST,
  SAVE_ACADEMIC_FIELDS_SUCCESS,
} from '../../../constants';
import { normalizeAcademicFields } from '../../../services/academic/academic';

export const fetchAcademicFields =
  (i18n: I18n): PayexThunkAction =>
  async (dispatch, getState, { payex }) => {
    const state = getState();

    if (isFetching(state, 'academic')) {
      return Promise.resolve();
    }

    dispatch({
      type: FETCH_ACADEMIC_REQUEST,
    });
    const recipient = getRecipientId(state) as string;
    const required =
      (getFieldValue(state, PROMOTIONS_OPT_IN_FIELD) as boolean) || false;

    if (!recipient) {
      return;
    }

    try {
      const response = await payex.academic.fetch(
        { recipient, required },
        { i18n },
      );
      const { fields = [] } = response;
      const payload = normalizeAcademicFields(fields);

      if (!isEmpty(payload)) {
        dispatch({
          type: FETCH_ACADEMIC_SUCCESS,
          payload,
        });
      }
    } catch (error) {
      errorNotifier.notify(error);

      dispatch({ type: FETCH_ACADEMIC_FAILURE });
    }
  };

export const saveAcademicFields =
  (request: SaveAcademicParams): PayexThunkAction =>
  async (dispatch, getState, { payex }) => {
    const state = getState();

    if (isFetching(state, 'academic')) {
      return Promise.resolve();
    }

    dispatch({
      type: SAVE_ACADEMIC_FIELDS_REQUEST,
    });

    try {
      await payex.academic.save(request);

      return dispatch({ type: SAVE_ACADEMIC_FIELDS_SUCCESS });
    } catch (error) {
      errorNotifier.notify(error);

      return dispatch({
        type: SAVE_ACADEMIC_FIELDS_FAILURE,
      });
    }
  };
